import { EqualsIcon } from '@heroicons/react/24/outline';
import { Item as DropdownMenuItem } from '@radix-ui/react-dropdown-menu';
import { useState } from 'react';

import { ButtonDropdown } from '@/components/core/ButtonDropdown/ButtonDropdown';
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from '@/components/core/DropdownMenu/DropdownMenu';

import { DEFAULT_FILTER_OPERATOR, FILTER_OPERATORS, FilterOperatorOption } from './FilterBuilder.types';

interface OperatorSelectProps {
    value?: string;
    onChange: (operatorKey: string) => void;
}

function displayValue(operatorKey?: string): string {
    const match = FILTER_OPERATORS.find((operator) => operator.key === operatorKey);
    return match?.value ?? operatorKey ?? FILTER_OPERATORS[0].value;
}

const OperatorSelect = ({ value = DEFAULT_FILTER_OPERATOR, onChange }: OperatorSelectProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const label = displayValue(value);

    return (
        <div className="tw-shrink-0 tw-max-w-full">
            <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
                <DropdownMenuTrigger asChild={true}>
                    <ButtonDropdown
                        icon={label === '=' ? EqualsIcon : undefined}
                        titleOne={label === '=' ? '' : label}
                        isOpen={isOpen}
                        aria-label={label}
                    />
                </DropdownMenuTrigger>
                <DropdownMenuContent
                    align="start"
                    hasBorder={true}
                    hasPadding={false}
                    className="tw-min-w-[5rem]"
                >
                    {FILTER_OPERATORS.map((operator: FilterOperatorOption) => (
                        <DropdownMenuItem
                            key={operator.key}
                            className="tw-flex tw-items-center tw-px-3 tw-py-2 tw-text-t-sm tw-cursor-pointer tw-outline-none
                                data-[highlighted]:tw-bg-fill-primary-hover hover:tw-bg-fill-primary-hover"
                            onSelect={() => onChange(operator.key)}
                        >
                            {operator.value}
                        </DropdownMenuItem>
                    ))}
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};

OperatorSelect.displayName = 'OperatorSelect';

export { OperatorSelect };
